import axios from '@/utils/request'

// 【择校】学科管理列表
export function getSchoolMajors(params) {
  return axios.get(`/admin_api/v1/school/majors/`, { params })
}

// 【择校-页面管理】添加楼层
export function postSchoolFloor(data) {
  return axios.post(`/admin_api/v1/school/floor/`, data)
}

// 【择校-页面管理】楼层列表
export function getSchoolFloorList(params) {
  return axios.get(`/admin_api/v1/school/floor/`, { params })
}

// 【择校-页面管理】楼层展示/隐藏
export function patchSchoolFloorShow(floor_id, data) {
  return axios.patch(`/admin_api/v1/school/floor/${floor_id}/`, data)
}

// 【择校-页面管理】修改楼层
export function patchSchoolFloor(floor_id, data) {
  return axios.patch(`/admin_api/v1/school/floor/${floor_id}/`, data)
}

// 【择校-页面管理】楼层详情
export function getSchoolFloor(floor_id) {
  return axios.get(`/admin_api/v1/school/floor/${floor_id}/`)
}

// 【择校-页面管理】删除楼层
export function deleteSchoolFloor(floor_id) {
  return axios.delete(`/admin_api/v1/school/floor/${floor_id}/`)
}

// 【择校-页面管理】楼层模版内容添加
export function postSchoolFloorContent(floor_id, data) {
  return axios.post(`/admin_api/v1/school/floor/${floor_id}/content/`, data)
}

// 【择校-页面管理】楼层模版内容修改
export function putSchoolFloorContent(floor_id, content_id, data) {
  return axios.put(`/admin_api/v1/school/floor/${floor_id}/content/${content_id}/`, data)
}

// 【择校-页面管理】楼层模版内容详情
export function getSchoolFloorContent(floor_id, content_id) {
  return axios.get(`/admin_api/v1/school/floor/${floor_id}/content/${content_id}/`)
}

// 【择校-页面管理】楼层模版内容删除
export function deleteSchoolFloorContent(floor_id, content_id) {
  return axios.delete(`/admin_api/v1/school/floor/${floor_id}/content/${content_id}/`)
}

// 【择校-页面管理】楼层模版内容列表
export function getSchoolFloorContentList(floor_id, params) {
  return axios.get(`/admin_api/v1/school/floor/${floor_id}/content/`, {
    params,
  })
}

// 【择校-页面管理】学长学姐
export function getSchoolShowSenior(params) {
  return axios.get(`/admin_api/v1/school/show-senior/`, { params })
}

// 【择校-页面管理】学长学姐修改
export function putSchoolSenior(data) {
  return axios.put(`/admin_api/v1/school/show-senior/`, data)
}

// 【择校-页面管理】学长学姐资料上传
export function postSchoolSenior(data) {
  return axios.post(`/admin_api/v1/school/senior/`, data)
}

// 【择校-页面管理】学长学姐资料删除
export function deleteSchoolSenior(uuid) {
  return axios.delete(`/admin_api/v1/school/senior/${uuid}/`)
}

// 【择校-页面管理】学长学姐资料列表
export function getSchoolSeniorList(params) {
  return axios.get(`/admin_api/v1/school/senior/`, { params })
}

// 【择校-专业解读】专业解读信息
export function getSchoolVideo(uuid) {
  return axios.get(`/admin_api/v1/school/${uuid}/video/`)
}

// 【择校-专业解读】专业解读信息添加/修改
export function putSchoolVideo(uuid, data) {
  return axios.put(`/admin_api/v1/school/${uuid}/video/`, data)
}

// 【择校-备考群】备考群列表
export function getSchoolSocial(uuid, params) {
  return axios.get(`/admin_api/v1/school/${uuid}/social/`, { params })
}

// 【择校-备考群】修改备考群标签或排序
export function patchSchoolSocial(major_id, social, data) {
  return axios.patch(`/admin_api/v1/school/${major_id}/social/${social}/`, data)
}

// 【择校-备考群】删除备考群
export function deleteSchoolSocial(major_id, social) {
  return axios.delete(`/admin_api/v1/school/${major_id}/social/${social}/`)
}

// 【择校-备考群】添加备考群
export function postSchoolSocial(uuid, data) {
  return axios.post(`/admin_api/v1/school/${uuid}/social/`, data)
}

// 【择校】可添加备考群下拉列表
export function getSchoolDPSocial() {
  return axios.get(`/admin_api/v1/school/dp/social/`)
}

// 【择校-学科管理】热门院校列表
export function getSchoolHotSchool(uuid, params) {
  return axios.get(`/admin_api/v1/school/${uuid}/hot-school/`, { params })
}

// 【择校-学科管理】添加热门院校
export function postSchoolHotSchool(uuid, data) {
  return axios.post(`/admin_api/v1/school/${uuid}/hot-school/`, data)
}

// 【择校-学科管理】删除热门院校
export function deleteSchoolHotSchool(uuid, data) {
  return axios.delete(`/admin_api/v1/school/${uuid}/hot-school/`, {
    data,
  })
}

// 【择校-学科管理】热门院校修改排序
export function patchSchoolHotSchool(uuid, data) {
  return axios.patch(`/admin_api/v1/school/${uuid}/hot-school/`, data)
}

// 【择校】学校下拉列表
export function getSchoolDPSchool(params) {
  return axios.get(`/admin_api/v1/school/dp/school/`, { params })
}

// 【择校-页面管理】历年真题
export function getQuestionDetail() {
  return axios.get('/admin_api/v1/school/real/question/')
}

// 【择校-页面管理】保存历年真题
export function saveQuestionDetail(data) {
  return axios.put(`/admin_api/v1/school/real/question/`, data)
}

// 【择校-视频管理】视频列表
export function getVideoList(params) {
  return axios.get('/admin_api/v1/school/video/', { params })
}

//【择校-视频管理】修改视频状态
export function toggleStatus(id, params) {
  return axios.put('/admin_api/v1/school/video/' + id + '/modify/status/', params)
}

//【择校-视频管理】视频删除
export function deleteVideo(id) {
  return axios.delete('/admin_api/v1/school/video/management/' + id + '/')
}

//【择校-视频管理】视频集列表
export function getVideoSelectList() {
  return axios.get('/admin_api/v1/school/videoset/list/')
}

//【择校-视频管理】根据选择的视频集展示视频列表
export function getListCurrentList(params) {
  return axios.get('/admin_api/v1/school/videoset/retrieve/?uuid=' + params)
}

// 【择校-视频管理】批量导入
export function baseURL() {
  return ''
}
export function importTuition() {
  return baseURL() + '/admin_api/v1/school/video/create/list/'
}

//【择校-视频管理】新增视频
export function addSubjectVideo(data) {
  return axios.post(`/admin_api/v1/school/video/management/add/`, data)
}

//【择校-视频管理】编辑视频
export function editSubjectVideo(uuid, data) {
  return axios.put(`/admin_api/v1/school/video/management/${uuid}/`, data)
}

//【择校-视频管理】查看视频
export function getSubjectVideo(uuid) {
  return axios.get(`/admin_api/v1/school/video/management/${uuid}/`)
}

// 【择校-视频管理】位置-门类、一级学科列表
export function getCategoryList(params) {
  return axios.get(`/admin_api/v1/school/category/list/`, { params })
}
//【择校-视频管理】位置-二级学科列表
export function getSecondSubjectList(params) {
  return axios.get(`/admin_api/v1/school/second/sub/list/`, { params })
}
//【择校-视频管理】位置-学校列表
export function getSchoolList(params) {
  return axios.get(`/admin_api/v1/school/target/school/`, { params })
}

//【择校-视频管理】获取专业信息
export function getSpecialityList() {
  return axios.get('/admin_api/v1/school/category/first/second/list/')
}

//#region 学长学姐

/** 是否展示学长学姐模块 */
export function getSchoolSeniormateConfigInfo() {
  return axios.get(`/admin_api/v1/school/seniormate/module/config/info/`)
}

/** 设置是否展示 */
export function postSchoolSeniormateConfigUpdate(data) {
  return axios.post(`/admin_api/v1/school/seniormate/module/config/update/`, data)
}

/** 学长学姐创建及修改 */
export function postSchoolSeniormateCreateOrUpdate(data) {
  return axios.post(`/admin_api/v1/school/seniormate/create_or_update/`, data)
}

/** 学长学姐列表及过滤查询 */
export function getSchoolSeniormateList(params) {
  return axios.get(`/admin_api/v1/school/seniormate/list/`, {
    params,
  })
}

/** 学长学姐下架/上架 */
export function putSchoolSeniormateEnable(data) {
  return axios.put(`/admin_api/v1/school/seniormate/enable/`, data)
}

/** 学长学姐删除 */
export function deleteSchoolSeniormate(id) {
  return axios.delete(`/admin_api/v1/school/seniormate/delete/`, {
    params: { id },
  })
}

/** 学长学姐详情 */
export function getSchoolSeniormateDetail(id) {
  return axios.get(`/admin_api/v1/school/seniormate/detail/`, { params: { id } })
}

/** 按姓名搜索研究生 */
export function getSchoolSeniormateSearchGraduate(params) {
  return axios.get(`/admin_api/v1/school/seniormate/search/graduate/`, {
    params,
  })
}

/** 随机生成外显名称和头像 */
export function getSchoolSeniormateGenRandomInfo() {
  return axios.get(`/admin_api/v1/school/seniormate/gen/random/info/`)
}

/** 资料列表及过滤查询 */
export function getSchoolSeniormateResourceList(params) {
  return axios.get(`/admin_api/v1/school/seniormate/resource/list/`, {
    params,
  })
}

/** 资料详情 */
export function getSchoolSeniormateResourceDetail(id) {
  return axios.get(`/admin_api/v1/school/seniormate/resource/detail/`, {
    params: { id },
  })
}

/** 资料删除 */
export function deleteSchoolSeniormateResource(id) {
  return axios.delete(`/admin_api/v1/school/seniormate/resource/delete/`, {
    params: { id },
  })
}

/** 资料创建及修改 */
export function postSchoolSeniormateResourceCreateOrUpdate(data) {
  return axios.post(`/admin_api/v1/school/seniormate/resource/create_or_update/`, data)
}

/** 批量新增学长学姐-模板下载 */
export function getSchoolSeniormateBatchTemplateDownload() {
  return axios.get(`/admin_api/v1/school/seniormate/batch/create/template/download/`)
}

/** 批量新增学长学姐(excel导入) */
export function postSchoolSeniormateBatchCreate(data) {
  return axios.post(`/admin_api/v1/school/seniormate/batch/create/`, data)
}

/** 批量修改学长学姐-显示/隐藏 */
export function putSchoolSeniormateBatchEnable(data) {
  return axios.put(`/admin_api/v1/school/seniormate/batch/enable/`, data)
}

/** 批量修改学长学姐-考研年份 */
export function putSchoolSeniormateBatchUpdateGraduateYear(data) {
  return axios.put(`/admin_api/v1/school/seniormate/batch/update/graduate/year/`, data)
}

/** 批量修改资料年份 */
export function putSchoolSeniormateBatchUpdateResourceYear(data) {
  return axios.put(`/admin_api/v1/school/seniormate/batch/update/resource/year/`, data)
}

/** 搜索院校 */
export function getSchoolSeniormateSearchSchool(
  params = {
    year: undefined,
    name: '',
  }
) {
  return axios.get(`/admin_api/v1/school/seniormate/search/school`, { params })
}

/** 根据院校搜索专业 */
export function getSchoolSeniormateSearchMajor(
  params = {
    school_uuid: undefined,
    name: '',
  }
) {
  return axios.get(`/admin_api/v1/school/seniormate/search/major`, { params })
}

//#endregion
